import FirstLayer from "../Components/Homepage/FirstLayer"
const Homepage = () => {
    return (
        <div>
            <FirstLayer></FirstLayer>
        </div>
    )
}

export default Homepage